(ns ui.view.transaction-process.modals.decision.view
  (:require
   [common.localization :refer [tr]]
   [re-frame.core :as rf]
   [ui.components.modal.view :as modal]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.modals.decision.event :as event]
   [ui.view.transaction-process.modals.decision.model :as model]
   [ui.view.transaction-process.modals.decision.sections :as sections]
   [ui.view.transaction-process.modals.decision.sub :as sub]))

(defn- scroll-to-section!
  [section-id]
  (when-let [el (.getElementById js/document (str "decision-section-" (name section-id)))]
    (.scrollIntoView el #js {:behavior "smooth" :block "start"})))

(defn- nav-sidebar
  [sections]
  [:div {:class "w-44 shrink-0 border-r border-gray-200 bg-gray-50 p-3 flex flex-col gap-1"}
   (for [{:keys [id label]} (model/section-config sections)]
     ^{:key id}
     [:button {:class    "text-left px-3 py-2 rounded text-sm m-0 text-gray-600 hover:bg-white/60 hover:text-gray-900"
               :on-click #(scroll-to-section! id)}
      label])])

(defn- section-header
  [label]
  [:h4 {:class "m-0 font-semibold text-gray-900 mb-3 pt-2"} label])

(defn- all-sections
  [{:keys [ctx sections]}]
  (into
   [:div {:class "p-4 flex flex-col gap-6"}]
   (map (fn [{:keys [id label]}]
          ^{:key id}
          [:div {:id (str "decision-section-" (name id))}
           [section-header label]
           (case id
             :details      [sections/details-section {:ctx ctx}]
             :participants [sections/participants-section {:ctx ctx}]
             :conditions   [sections/conditions-section {:ctx ctx}]
             :reservations [sections/reservations-section {:ctx ctx}]
             :notes        [sections/notes-section {:ctx ctx}]
             nil)]))
   (model/section-config sections)))

(defn view
  [{:keys [ctx]}]
  (let [edit-mode?   @(rf/subscribe [::sub/edit-mode? ctx])
        submitting?  @(rf/subscribe [::sub/submitting? ctx])
        error        @(rf/subscribe [::sub/error ctx])
        type-label   @(rf/subscribe [::sub/decision-type-label ctx])
        sections     @(rf/subscribe [::sub/sections ctx])
        ready-errors @(rf/subscribe [::sub/ready-errors ctx])
        can-approve? @(rf/subscribe [::sub/can-approve? ctx])
        ;; Already approved and the user cannot approve: both saves would write
        ;; :decision/draft?, so the decision is read-only until the PM reopens it.
        approval-locked? @(rf/subscribe [::sub/approval-locked? ctx])
        title        (if type-label
                       (tr (if edit-mode?
                             :transaction-process/edit-decision-named
                             :transaction-process/log-decision-named)
                           [type-label])
                       (tr (if edit-mode?
                             :transaction-process/edit-decision
                             :transaction-process/log-decision)))]
    [modal/view
     {:visible?      true
      :hide!         #(rf/dispatch [::common/close ctx])
      :size          "80vw"
      :content-class "max-h-[85vh] max-w-[1400px]"
      :body-class    "p-0 lg:p-0"}
     title
     [:div {:class "flex flex-1 flex-col overflow-hidden"}
      (when error
        [:div {:class "px-4 pt-2"}
         [common/error-banner error]])
      [:div {:class "flex flex-1 overflow-hidden"}
       [nav-sidebar sections]
       [:div {:class "flex-1 overflow-auto"}
        [all-sections {:ctx ctx :sections sections}]]]]
     [common/save-footer
      {:submitting?          submitting?
       :ready-errors         ready-errors
       :save-draft-disabled? approval-locked?
       :save-ready-disabled? (not can-approve?)
       :save-draft-tooltip   (when approval-locked?
                               (tr :transaction-process/decision-approved-locked))
       :save-ready-tooltip   (when-not can-approve?
                               (tr (if approval-locked?
                                     :transaction-process/decision-approved-locked
                                     :transaction-process/decision-approval-not-permitted)))
       :on-cancel            #(rf/dispatch [::common/close ctx])
       :on-save-draft        #(rf/dispatch [::event/save ctx true])
       :on-save-ready        #(rf/dispatch [::event/save ctx false])}]]))
